
const Main = () => import('@/views/main');
const cashierPlatform = () => import('@/views/ticket-desk/cashier-platform');
const addCashierPlatform = () => import('@/views/ticket-desk/add-cashier-platform');
const ticketInfo = () => import('@/views/ticket-desk/ticket-info');
const retailInfo = () => import('@/views/ticket-desk/retail-info');
const storeValueInfo = () => import('@/views/ticket-desk/storeValue-info');
const addTicket = () => import('@/views/platform/addTicket');
const retailInfoDetail = () => import('@/views/ticket-desk/retail-info-detail');

const shopTicketCategory = () => import('@/views/shopTicket/ticket-category-manage');
const thirdTicketManage = () => import('@/views/shopTicket/mt-dy-sku-list');
const thirdProductManage = () => import('@/views/shopTicket/self-change-ticket-list');

export default [{
    path: '/shopTicket',
    name: 'shopTicket',
    redirect: {
        name: 'cashierPlatform'
    },
    component: Main,
    meta: {
        hide: false,
        name: '门店运营管理',
        unfold: true,
		iconType: "8"
    },
    children: [
        {
            path: "cashierPlatform",
            name: 'cashierPlatform',
            component: cashierPlatform,
            meta: {
                hide: true,
                name: "收银台列表"
            },
            children: [{
                    path: "addCashierDesk",
                    name: "addCashierDesk",
                    component: addCashierPlatform,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "新增收银台"
                    }
                },
                {
                    path: "updateCashierDesk/:id",
                    name: "updateCashierDesk",
                    component: addCashierPlatform,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "编辑收银台"
                    }
                },
                {
                    path: "cashierSaleInfo/:id",
                    name: "cashierSaleInfo",
                    component: ticketInfo,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "票券信息"
                    },
                    children: [{
                        path: "counterTicketDetail",
                        name: "counterTicketDetail",
                        component: addTicket,
                        meta: {
                            name: '票券信息详情'
                        },
                    }, ]
                },
                {
                    path: "cashierRetailInfo/:rid/:warehouseName",
                    name: "cashierRetailInfo",
                    component: retailInfo,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "零售信息"
                    },
                    children: [{
                        path: "retailInfoDetail/:id",
                        name: "retailInfoDetail",
                        component: retailInfoDetail,
                        meta: {
                            name: '零售信息详情'
                        },
                    }, ]
                },
                {
                    path: "cashierStoreValueInfo/:id",
                    name: "cashierStoreValueInfo",
                    component: storeValueInfo,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "储值卡信息"
                    },
                },
            ]
        },
        {
            path: 'shopTicketCategory',
            name: 'shopTicketCategory',
            component: shopTicketCategory,
            meta: {
                name: '票券展示管理'
            },
            children: [
                {
					path: "categoryTicketDetail/:ticketTemplateId",
					component: addTicket,
					name: "categoryTicketDetail",
					meta: {
						name: '票券详情'
					},
				},
            ]
        },
        {
            path: 'thirdTicketManage',
            name: 'thirdTicketManage',
            component: thirdTicketManage,
            meta: {
                name: '三方票映射管理'
            },
        },
        {
            path: 'thirdProductManage',
            name: 'thirdProductManage',
            component: thirdProductManage,
            meta: {
                name: '三方换票映射管理'
            },
        },
    ]
}]

